var React = require('react');

function CheckCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m-1.01-3.613 5.636-7.09-1.252-.995-4.54 5.71-2.678-2.587-1.112 1.15z"}));
}

CheckCircleSolid.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = CheckCircleSolid;

CheckCircleSolid.default = CheckCircleSolid;
